import axios from "axios";

const _axios = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL || "",
});

_axios.interceptors.request.use((req) => {
  const token = localStorage.getItem("handler_token");
  if (token) req.headers["Authorization"] = `Token ${token}`;
  return req;
});

export default _axios;
